import { ref } from 'vue'
import { fetchUserDashboard, type UserDashboardResponse } from '../api/client'

const dashboard = ref<UserDashboardResponse | null>(null)
const loading = ref(false)
const DASHBOARD_CACHE_TTL = 30_000

let dashboardPromise: Promise<UserDashboardResponse | null> | null = null
let lastLoadedAt = 0

export function useDashboardData() {
  async function loadDashboard(force = false) {
    const now = Date.now()
    if (!force && dashboard.value && now - lastLoadedAt < DASHBOARD_CACHE_TTL) {
      return dashboard.value
    }

    if (dashboardPromise) {
      return dashboardPromise
    }

    loading.value = true
    dashboardPromise = fetchUserDashboard()
      .then((data) => {
        dashboard.value = data
        lastLoadedAt = Date.now()
        return data
      })
      .finally(() => {
        loading.value = false
        dashboardPromise = null
      })

    return dashboardPromise
  }

  function invalidateDashboard() {
    lastLoadedAt = 0
  }

  return {
    dashboard,
    loading,
    loadDashboard,
    invalidateDashboard,
  }
}